import React, { useState, useEffect } from "react";
import { Progress } from "antd";
function Dash() {
  return (
    <div
      style={{ display: "flex", margin: "0 23px 0 0", flexDirection: "column" }}
    ></div>
  );
}

export default Dash;
